/**
 * A plain link, not a fetch: sign-in is a full-page redirect through the BFF to
 * Microsoft and back. The browser follows /auth/login → Entra → /auth/callback → /.
 */
export function SignIn({ errorMessage }) {
  return (
    <section className="card card--center">
      <h1>Sign in</h1>
      <p className="muted">Sign in using your m365 account here.</p>
      {errorMessage && (
        <p className="alert alert--error" role="alert">
          {errorMessage}
        </p>
      )}
      <a className="button" href="/auth/login">
        Sign in with Microsoft
      </a>
    </section>
  );
}
